module.exports = __webpack_public_path__ + "media/recipes/157-808485da.png";